export const VAULT_PRODUCT_ID: number = 1; // product id in IDM

export enum VAULT_MEDIA_TYPE {
  video = 'Video',
  image = 'Image',
  document = 'Document',
  virtualAsset = 'VirtualAsset',
  audio = 'Audio',
  clip = 'Clip',
  liveVideo = 'Live Video',
}

export enum VAULT_VIDEO_TYPE {
  Exchange = 'Exchange',
  Vault = 'Vault',
  MyVault = 'MyVault',
  SelfScout = 'SelfScout',
  Clip = 'Clip',
  LiveClip = 'Live Clip',
  LiveStream = 'Live Stream',
}

export const SUPPORT_EMAIL_ADDRESS = 'ExchangeSupport@catapultsports.com';
